module.exports = __webpack_public_path__ + "0314f6ecc850d3cc41a60309031cde96.pdf";